import WizardStep from '../components/wizard/Wizard.Step';

export default {

  components: {
    WizardStep,
  },

  data() {
    return {
      curStep: 1,
    };
  },

  mounted() {
    const step = Number(this.$route.query.step);
    if (step && !Number.isNaN(step)) {
      this.curStep = Number(this.$route.query.step);
    } else {
      this.curStep = 1;
    }
  },

  computed: {

    step() {
      return Number(this.$route.query.step);
    },

  },

  methods: {

    decrementStep() {
      console.log('decrementStep');
      this.curStep = this.step - 1;
    },

    incrementStep() {
      console.log('----------');
      console.log('incrementStep');
      console.log(`this.totalSteps: ${this.totalSteps}`);
      console.log(`this.step: ${this.step}`);
      console.log(`this.curStep: ${this.curStep}`);
      if (this.step < this.totalSteps) {
        this.curStep = this.step + 1;
      } else {
        this.$router.push({
          name: 'wizard-offerings',
          hash: '#offerings',
          query: {
            category: this.$route.meta.category,
          }
        });
      }
    },

    setStepQueryParam(step) {
      const query = { ...this.$route.query, step, };
      this.$router.push({ query, });
    },

  },

  watch: {

    curStep(step) {
      this.setStepQueryParam(step);
    },

    $route($route) {
      if ($route.query.step) {
        this.curStep = Number($route.query.step);
      }
    },

  },

};
